import React from 'react'
import Navbar from '../components/navbar.js';
import Body from '../components/body.js';
import Footer from '../components/footer.js';
import '../App.js';
const Home = () => {
  return (
    <>   
        <Navbar />
        <Body />
        <Footer />
    </>
  )
}

export default Home